import * as yup from "yup";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { FormInputMeta } from '@Modules/core/types/FormMetaType';

// We can follow the exemple of this file /src/modules/admin/archiving/containers/formHandlers/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsFormMeta.ts

export interface IIncomingSummaryDetailsFormMeta {
  
  date: FormInputMeta;
  bin: FormInputMeta;
  bankCorporateName: FormInputMeta;
  //
  schema: any;
}

const IncomingSummaryDetailsFormMeta = {} as IIncomingSummaryDetailsFormMeta;

IncomingSummaryDetailsFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date',
  placeholder: '',
  disabled: true,
  validation: yup.string().required("Ce champ est requis"),
};
IncomingSummaryDetailsFormMeta.bin = {
  name: 'bin',
  type: 'text',
  label: 'BIN',
  placeholder: '',
  disabled: true,
  validation: yup.string().required("Ce champ est requis"),
};
IncomingSummaryDetailsFormMeta.bankCorporateName = {
  name: 'bankCorporateName',
  type: 'text',
  label: 'Bank Corporate Name',
  placeholder: '',
  disabled: true,
  validation: yup.string().required("Ce champ est requis"),
};


IncomingSummaryDetailsFormMeta.schema = yup.object().shape(getValidationSchema(IncomingSummaryDetailsFormMeta));

export default IncomingSummaryDetailsFormMeta;